
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/fetch-cic-csv",
      function () {
        return require("private-next-pages/admin/fetch-cic-csv/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/fetch-cic-csv"])
      });
    }
  